import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ResourcesState {
  bgLoaded: boolean;
  personsLoaded: boolean;
}

const initialState: ResourcesState = {
  bgLoaded: false,
  personsLoaded: false,
};

export const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    setBGLoaded: (state, action: PayloadAction<boolean>) => {
      state.bgLoaded = action.payload;
    },
    setPersonsLoaded: (state, action: PayloadAction<boolean>) => {
      state.personsLoaded = action.payload;
    },
  },
});

export const { setBGLoaded, setPersonsLoaded } = resourcesSlice.actions;

export const getBGLoaded = (state: RootState) => state.resources.bgLoaded;
export const getPersonsLoaded = (state: RootState) => state.resources.personsLoaded;

export const resourcesReducer = resourcesSlice.reducer;
